/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAuctionResponse } from '../../models/get-auction-response';

export interface AuctionServiceGetAuction$Params {
  auctionId: string;
}

export function auctionServiceGetAuction(http: HttpClient, rootUrl: string, params: AuctionServiceGetAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAuctionResponse>> {
  const rb = new RequestBuilder(rootUrl, auctionServiceGetAuction.PATH, 'get');
  if (params) {
    rb.path('auctionId', params.auctionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAuctionResponse>;
    })
  );
}

auctionServiceGetAuction.PATH = '/api/v3/gateway/auctions/{auctionId}';
